import React from 'react';
import PropTypes from 'prop-types';

const SearchErrorHandler = (props) => {
    const { children } = props
    return (
        <div className="d-flex h-100">
            <div className="m-auto text-center">
                <i className="fa-regular fa-folder-open fa-2x mb-2"></i>
                <p> No Result Found</p>
                {children}
            </div>
        </div>
    );
};

SearchErrorHandler.propTypes = {
    children: PropTypes.node,
};

SearchErrorHandler.defaultProps = {
    children: null,
};

export default SearchErrorHandler;
